{
  "meta": {
    "title": "TYCE",
    "description": "Custom description"
  },
  "global": {
    "skip": "Skip",
    "exit": "Exit",
    "continue": "Continue",
    "nextChapter": "Continue my day",
    "mute": "Mute",
    "unmute": "Unmute"
  },
  "header": {
    "back": "Exit the simulation",
    "presentation": "A day with <name>{{persona}}</name>"
  },
  "questions": {
    "summary": {
      "detail": "What I know about you ... You're a <tag>{{ relationship }}</tag> curious about <tag>{{ difference }}</tag>",
      "confirmation": "is that correct?",
      "yes": "Yes, let's start!",
      "no-back": "No, take me back",
      "no-start": "No, but let's continue on"
    },
    "preliminary": {
      "relationship": {
        "question": "Hi, nice to meet you! \nBefore we begin, you are...",
        "educator": "an educator",
        "parent": "a parent",
        "child": "a kid!"
      }
    },
    "true": "True",
    "false": "False",
    "good": "Good",
    "neutral": "Neutral",
    "bad": "Bad",
    "likert": {
      "1": "Strongly agree",
      "2": "Agree",
      "3": "Neither",
      "4": "Disagree",
      "5": "Strongly disagree",
      "introduction": "Tell me how much you agree with the statement below.",
      "instruction": "Drag or click to answer",
      "drag": "Drag"
    },
    "aria": {
      "preliminary": {
        "heading": "Confirmation question",
        "instruction": "Click on one of the 3 possible following answers:"
      },
      "binary": {
        "heading": "True/False question {{step}} on {{max}}"
      },
      "likert": {
        "heading": "Likert question {{step}} on {{max}}",
        "instruction": "Choose one of the 5 possible answers with either drag or click and then validate with the next button."
      },
      "feedback": {
        "heading": "Feedback question"
      },
      "explanation": {
        "previous": "Previous",
        "next": "Next"
      }
    },
    "explanation": {
      "continue": "Continue"
    },
    "pedro": {
      "0": {
        "before": {
          "binary": {
            "1": "Question 1 of 3:<br/> Distraction can be a big issue for people with ADHD.",
            "2": "Question 2 of 3:<br/> Structure and routines can help people with ADHD stay organized and get things done.",
            "3": "Question 3 of 3:<br/> People with ADHD can have difficulty managing their emotions.",
            "introduction": "I’d like to get your thoughts about ADHD. Please answer the following questions."
          },
          "likert": {
            "1": "I feel like people with ADHD are different from me.",
            "2": "I feel frustrated when people with ADHD leave tasks undone.",
            "3": "I feel sorry for people with ADHD, because they need to put in extra effort every day.",
            "4": "I think that people with ADHD receive special treatment."
          }
        },
        "after": {
          "binary": {
            "1": "Question 1 of 3:<br/> Distraction can be a big issue for people with ADHD.",
            "2": "Question 2 of 3:<br/> Structure and routines can help people with ADHD stay organized and get things done.",
            "3": "Question 3 of 3:<br/> People with ADHD can have difficulty managing their emotions.",
            "introduction": "Now that you’ve seen through my eyes, let’s see if any of your thoughts have changed about ADHD. Please answer the same questions as before. And at the end, I’ll tell you the answers to the true/false questions."
          },
          "explanation": {
            "1": {
              "text": "People with ADHD may lose focus easily, but sometimes they can hyperfocus on things that really interest them.",
              "isTrue": "TRUE"
            },
            "2": {
              "text": "ADHD can make it hard to get and stay organized, but structure and routines can be a big help.",
              "isTrue": "TRUE"
            },
            "3": {
              "text": "Trouble with managing emotions can lead to big feelings about small things, but calming strategies can help manage some emotions, like stress and anxiety.",
              "isTrue": "TRUE"
            }
          },
          "likert": {
            "1": "I feel like people with ADHD are different from me.",
            "2": "I feel frustrated when people with ADHD leave tasks undone.",
            "3": "I feel sorry for people with ADHD, because they need to put in extra effort every day.",
            "4": "I think that people with ADHD receive special treatment."
          }
        }
      },
      "1": {
        "before": {
          "binary": {
            "1": "Question 1 of 3:<br/>Impulse control can be challenging for people with ADHD.",
            "2": "Question 2 of 3:<br/>Reminders can help people with ADHD stay organized and get things done.",
            "3": "Question 3 of 3:<br/>Daydreaming can be distracting for people with ADHD.",
            "introduction": "I’d like to get your thoughts about ADHD. Please answer the following questions."
          },
          "likert": {
            "1": "I feel like people with ADHD are different from me.",
            "2": "I feel frustrated when people with ADHD leave tasks undone.",
            "3": "I feel sorry for people with ADHD, because they need to put in extra effort every day.",
            "4": "I think that people with ADHD receive special treatment."
          }
        },
        "after": {
          "binary": {
            "1": "Question 1 of 3:<br/>Impulse control can be challenging for people with ADHD.",
            "2": "Question 2 of 3:<br/>Reminders can help people with ADHD stay organized and get things done.",
            "3": "Question 3 of 3:<br/>Daydreaming can be distracting for people with ADHD.",
            "introduction": "Now that you’ve seen through my eyes, let’s see if any of your thoughts have changed about ADHD. Please answer the same questions as before. And at the end, I’ll tell you the answers to the true/false questions."
          },
          "explanation": {
            "1": {
              "text": "ADHD can make it difficult to do things like sit still or not interrupt others, but taking breaks and moving around can help.",
              "isTrue": "TRUE"
            },
            "2": {
              "text": "ADHD can make it hard to get and stay organized, but reminders can help them refocus.",
              "isTrue": "TRUE"
            },
            "3": {
              "text": "People with ADHD can get lost in their own thoughts, but using sensory tools and other strategies can help them stay on task.",
              "isTrue": "TRUE"
            }
          },
          "likert": {
            "1": "I feel like people with ADHD are different from me.",
            "2": "I feel frustrated when people with ADHD leave tasks undone.",
            "3": "I feel sorry for people with ADHD, because they need to put in extra effort every day.",
            "4": "I think that people with ADHD receive special treatment."
          }
        }
      }
    },
    "caris": {
      "0": {
        "before": {
          "binary": {
            "1": "Question 1 of 3:<br/> Problems with vision are not the cause of dyslexia.",
            "2": "Question 2 of 3:<br/> Spelling can be a big challenge for people with dyslexia.",
            "3": "Question 3 of 3:<br/> The right kind of instruction and support can help people with dyslexia be better readers.",
            "introduction": "I’d like to get your thoughts about dyslexia. Please answer the following questions."
          },
          "likert": {
            "1": "I feel like people with dyslexia are different from me.",
            "2": "I feel frustrated when people with dyslexia leave tasks undone.",
            "3": "I feel sorry for people with dyslexia, because they need to put in extra effort every day.",
            "4": "I think that people with dyslexia receive special treatment."
          }
        },
        "after": {
          "binary": {
            "1": "Question 1 of 3:<br/> Problems with vision are not the cause of dyslexia.",
            "2": "Question 2 of 3:<br/> Spelling can be a big challenge for people with dyslexia.",
            "3": "Question 3 of 3:<br/> The right kind of instruction and support can help people with dyslexia be better readers.",
            "introduction": "Now that you’ve seen through my eyes, let’s see if any of your thoughts have changed about dyslexia. Please answer the same questions as before. And at the end, I’ll tell you the answers to the true/false questions."
          },
          "explanation": {
            "1": {
              "text": "Dyslexia is a brain difference that can make it harder to work with language, especially the sounds of letters, syllables, and words. It’s not about vision or how well you see.",
              "isTrue": "TRUE"
            },
            "2": {
              "text": "Sounding out words and figuring out the direction of letters can be difficult for people with dyslexia, and this can make spelling even harder.",
              "isTrue": "TRUE"
            },
            "3": {
              "text": "Teaching phonics and other reading skills in a clear, step-by-step way can help all students learn to read, but it is extra helpful for people with dyslexia.",
              "isTrue": "TRUE"
            }
          },
          "likert": {
            "1": "I feel like people with dyslexia are different from me.",
            "2": "I feel frustrated when people with dyslexia leave tasks undone.",
            "3": "I feel sorry for people with dyslexia, because they need to put in extra effort every day.",
            "4": "I think that people with dyslexia receive special treatment."
          }
        }
      },
      "1": {
        "before": {
          "binary": {
            "1": "Question 1 of 3:<br/> Having dyslexia doesn’t mean someone isn’t smart.",
            "2": "Question 2 of 3:<br/> Dyslexia can involve trouble remembering left from right. ",
            "3": "Question 3 of 3:<br/> Dyslexia can make it difficult to follow directions, especially when a task has many steps.",
            "introduction": "I’d like to get your thoughts about dyslexia. Please answer the following questions."
          },
          "likert": {
            "1": "I feel like people with dyslexia are different from me.",
            "2": "I feel frustrated when people with dyslexia leave tasks undone.",
            "3": "I feel sorry for people with dyslexia, because they need to put in extra effort every day.",
            "4": "I think that people with dyslexia receive special treatment."
          }
        },
        "after": {
          "binary": {
            "1": "Question 1 of 3:<br/> Having dyslexia doesn’t mean someone isn’t smart.",
            "2": "Question 2 of 3:<br/> Dyslexia can involve trouble remembering left from right. ",
            "3": "Question 3 of 3:<br/> Dyslexia can make it difficult to follow directions, especially when a task has many steps.",
            "introduction": "Now that you’ve seen through my eyes, let’s see if any of your thoughts have changed about dyslexia. Please answer the same questions as before. And at the end, I’ll tell you the answers to the true/false questions."
          },
          "explanation": {
            "1": {
              "text": "It’s a difference in the brain that can make it harder to remember certain things, but it has nothing to do with intelligence.",
              "isTrue": "TRUE"
            },
            "2": {
              "text": "Dyslexia often involves challenges with sense of direction. This can make it hard to learn left from right.",
              "isTrue": "TRUE"
            },
            "3": {
              "text": "It can be hard for people with dyslexia to remember things in the right order, like the letters in a word or the steps to finish a big task.",
              "isTrue": "TRUE"
            }
          },
          "likert": {
            "1": "I feel like people with dyslexia are different from me.",
            "2": "I feel frustrated when people with dyslexia leave tasks undone.",
            "3": "I feel sorry for people with dyslexia, because they need to put in extra effort every day.",
            "4": "I think that people with dyslexia receive special treatment."
          }
        }
      }
    },
    "francesca": {
      "0": {
        "before": {
          "binary": {
            "1": "Question 1 of 3:<br/> People with dyscalculia can have difficulty remembering math facts, like 2 + 4 = 6.",
            "2": "Question 2 of 3:<br/> Hands-on tools and visual aids, like number lines, can help people with dyscalculia understand math concepts.",
            "3": "Question 3 of 3:<br/> Dyscalculia and math anxiety are not the same thing.",
            "introduction": "I’d like to get your thoughts about dyscalculia. Please answer the following questions."
          },
          "likert": {
            "1": "I feel like people with dyscalculia are different from me.",
            "2": "I feel frustrated when people with dyscalculia leave tasks undone.",
            "3": "I feel sorry for people with dyscalculia, because they need to put in extra effort every day.",
            "4": "I think that people with dyscalculia receive special treatment."
          }
        },
        "after": {
          "binary": {
            "1": "Question 1 of 3:<br/> People with dyscalculia can have difficulty remembering math facts, like 2 + 4 = 6.",
            "2": "Question 2 of 3:<br/> Hands-on tools and visual aids, like number lines, can help people with dyscalculia understand math concepts.",
            "3": "Question 3 of 3:<br/> Dyscalculia and math anxiety are not the same thing.",
            "introduction": "Now that you’ve seen through my eyes, let’s see if any of your thoughts have changed about dyscalculia. Please answer the same questions as before. And at the end, I’ll tell you the answers to the true/false questions."
          },
          "explanation": {
            "1": {
              "text": "Dyscalculia is a difference in the brain that can make it hard to remember math facts, because the brain may not easily see how numbers work with one another.",
              "isTrue": "TRUE"
            },
            "2": {
              "text": "Things you can hold or see, like blocks, lines, or charts, help make numbers clearer and show how they work together.",
              "isTrue": "TRUE"
            },
            "3": {
              "text": "Dyscalculia is a learning difference, while math anxiety is an intense feeling of worry about math. They are different things, but they often overlap.",
              "isTrue": "TRUE"
            }
          },
          "likert": {
            "1": "I feel like people with dyscalculia are different from me.",
            "2": "I feel frustrated when people with dyscalculia leave tasks undone.",
            "3": "I feel sorry for people with dyscalculia, because they need to put in extra effort every day.",
            "4": "I think that people with dyscalculia receive special treatment."
          }
        }
      },
      "1": {
        "before": {
          "binary": {
            "1": "Question 1 of 3:<br/> People with dyscalculia can find it hard to do math in their heads.",
            "2": "Question 2 of 3:<br/> Working with money and coins can be difficult for people with dyscalculia.",
            "3": "Question 3 of 3:<br/> Using math tools, like a calculator, can help people with dyscalculia complete a math task.",
            "introduction": "I’d like to get your thoughts about dyscalculia. Please answer the following questions."
          },
          "likert": {
            "1": "I feel like people with dyscalculia are different from me.",
            "2": "I feel frustrated when people with dyscalculia leave tasks undone.",
            "3": "I feel sorry for people with dyscalculia, because they need to put in extra effort every day.",
            "4": "I think that people with dyscalculia receive special treatment."
          }
        },
        "after": {
          "binary": {
            "1": "Question 1 of 3:<br/> People with dyscalculia can find it hard to do math in their heads.",
            "2": "Question 2 of 3:<br/> Working with money and coins can be difficult for people with dyscalculia.",
            "3": "Question 3 of 3:<br/> Using math tools, like a calculator, can help people with dyscalculia complete a math task.",
            "introduction": "Now that you’ve seen through my eyes, let’s see if any of your thoughts have changed about dyscalculia. Please answer the same questions as before. And at the end, I’ll tell you the answers to the true/false questions."
          },
          "explanation": {
            "1": {
              "text": "Dyscalculia can make it hard to understand how numbers work together, so it helps to move objects around or use other kinds of visual aids.",
              "isTrue": "TRUE"
            },
            "2": {
              "text": "Dyscalculia can make it harder to remember the sizes, shapes, and values of money.",
              "isTrue": "TRUE"
            },
            "3": {
              "text": "Math problems often involve several steps. A calculator can help people with dyscalculia by doing some of the work, like remembering basic math facts.",
              "isTrue": "TRUE"
            }
          },
          "likert": {
            "1": "I feel like people with dyscalculia are different from me.",
            "2": "I feel frustrated when people with dyscalculia leave tasks undone.",
            "3": "I feel sorry for people with dyscalculia, because they need to put in extra effort every day.",
            "4": "I think that people with dyscalculia receive special treatment."
          }
        }
      }
    }
  },
  "tutorial": {
    "title": "Choose a scenario:",
    "completed-title": "Choose another scenario:",
    "previous": "Previous",
    "skip": "Next",
    "next": "Next",
    "start": "Start",
    "choose": "Choose",
    "start-over": "Start over",
    "lets-move-on": "Let's move on",
    "tap-arrows": "Tap on arrows to move!",
    "aria": {
      "previous": "Show previous tutorial step",
      "next": "Show next tutorial step",
      "start": "Start the simulation",
      "pagination": "Step {{step}} on {{max}}"
    },
    "pedro": {
      "1": {
        "intro": {
          "icon": "bowlFull",
          "title": "Morning \nroutine",
          "description": "My school starts at <tag>8 a.m.</tag> sharp! <br/>Help me <tag>get ready</tag> so I can get to school <tag>on time</tag>.",
          "cta": "Let's go!"
        }
      },
      "2": {
        "intro": {
          "icon": "pomme",
          "title": "Science \nclass",
          "description": "Today I have <tag>science class</tag>. Help me <tag>follow</tag> the <tag>lesson</tag> so I don’t <tag>fall behind</tag>.",
          "cta": "Let’s go!"
        }
      }
    },
    "caris": {
      "1": {
        "intro": {
          "icon": "journal",
          "title": "Social studies \nclass",
          "description": "Come with me to <tag>social studies</tag> class. <tag>Help me</tag> get my work done.",
          "cta": "Let’s go!"
        }
      },
      "2": {
        "intro": {
          "icon": "legs",
          "title": "Dance \naudition",
          "description": "Help me rock my <tag>dance audition</tag>. Grab the <tag>correct moves</tag> as you go.",
          "cta": "Let’s go!"
        }
      }
    },
    "francesca": {
      "1": {
        "intro": {
          "icon": "mathClass",
          "title": "Math \nclass",
          "description": "Math is my <tag>first class</tag> of the day. Come with me and <tag>help me</tag> pass my <tag>test</tag>.",
          "cta": "Let's go!"
        }
      },
      "2": {
        "intro": {
          "icon": "receipt",
          "title": "Grocery \nstore",
          "description": "Help me get <tag>all the items</tag> on my list without spending <tag>too much</tag>.",
          "cta": "Let's go!"
        }
      }
    }
  },
  "tooltips": {
    "move": {
      "text": "To move: use left and right arrows.",
      "play_once": "true"
    },
    "move_desktop": {
      "text": "To move: use ⬅️ ➡️ left and right arrow keys.",
      "play_once": "true"
    },
    "pause": {
      "text": "To pause: use this button to take a break.",
      "play_once": "true",
      "element": "#pause_button"
    },
    "stick": {
      "text": "💪 Stick with it.  It's okay if this one feels hard."
    },
    "watch": {
      "text": "Prefer to watch first? See an expert explain it.",
      "cta": "Watch",
      "link": "https://www.understood.org/en/through-my-eyes/pedro-morning-routine",
      "duration": "5000",
      "play_once": "true"
    }
  },
  "runner": {
    "play": "Play",
    "pause": "Pause",
    "next": "Next",
    "cta": "Let's go",
    "resume": "Resume",
    "exit": "Exit",
    "pause_screen": {
      "tag": "Pause",
      "title": "Take <br/>a <color>break</color>",
      "text": "Breaks give your brain a chance to reset.",
      "sticker": "popin_freeze",
      "background": "background3",
      "color": "3"
    },
    "pedro": {
      "1": {
        "popin1": {
          "steps": "1",
          "step": {
            "1": {
              "type": "goal",
              "tag": "1st goal",
              "title": "Brush your <color>teeth!</color>",
              "text": "Collect items in the bathroom in the right order.",
              "sticker": "popin_pedro_1_1_goal",
              "background": "background3",
              "color": "0"
            }
          }
        },
        "popin2": {
          "steps": "3",
          "step": {
            "1": {
              "type": "goal",
              "tag": "2nd goal",
              "title": "Now get <color>dressed!</color>",
              "text": "Collect clothes to wear in the right order.",
              "sticker": "popin_pedro_1_2_goal",
              "background": "background3",
              "color": "0"
            },
            "2": {
              "type": "bonus",
              "tag": "Collect a bonus",
              "title": "Do some <color>stretching!</color>",
              "text": "Stretching helps when things get stressful.",
              "sticker": "popin_pedro_1_2_bonus",
              "background": "background4",
              "audio": "p1_dress_stretching_explainer",
              "color": "1"
            },
            "3": {
              "type": "obstacle",
              "tag": "Avoid the obstacle",
              "title": "Tune out <color>the TV!</color>",
              "text": "Don’t get distracted by your favorite show.",
              "sticker": "popin_pedro_1_2_malus",
              "background": "background2",
              "color": "2",
              "audio": "p1_dress_television_explainer"
            }
          }
        },
        "popin3": {
          "steps": "1",
          "step": {
            "1": {
              "type": "goal",
              "tag": "Final goal",
              "title": "Eat <color>breakfast!</color>",
              "text": "Make a bowl of cereal in the right order.",
              "sticker": "popin_pedro_1_3_goal",
              "background": "background3",
              "color": "0"
            }
          }
        }
      },
      "2": {
        "jauge": {
          "label": "Frustration"
        },
        "timeline": {
          "label": "Timeline"
        },
        "popin1": {
          "steps": "1",
          "step": {
            "1": {
              "type": "goal",
              "tag": "1st goal",
              "title": "Follow the <color>lesson!</color>",
              "text": "Collect the matching objects in the science lesson.",
              "sticker": "popin_pedro_2_1_goal",
              "audio": "p2_intro_explainer",
              "background": "background3",
              "color": "0"
            }
          }
        },
        "popin2": {
          "steps": "1",
          "step": {
            "1": {
              "type": "obstacle",
              "tag": "Avoid the obstacle",
              "title": "Class <color>clown</color>",
              "text": "Fight the impulse to crack funny jokes.",
              "sticker": "popin_pedro_2_2_malus",
              "audio": "p2_clown_explainer_A",
              "background": "background2",
              "color": "2"
            }
          }
        },
        "popin3": {
          "steps": "2",
          "step": {
            "1": {
              "type": "bonus",
              "tag": "Collect a bonus",
              "title": "Hyper<color>focus</color>",
              "text": "Zero in on the right answer.",
              "sticker": "popin_pedro_2_3_bonus",
              "background": "background4",
              "color": "1"
            },
            "2": {
              "type": "obstacle",
              "tag": "Avoid the obstacle",
              "title": "Pixelated <color>brain</color>",
              "text": "Losing focus makes everything fuzzy.",
              "sticker": "popin_pedro_2_3_malus",
              "audio": "p2_pixelated_brain_explainer",
              "background": "background2",
              "color": "2"
            }
          }
        },
        "popin4": {
          "steps": "1",
          "step": {
            "1": {
              "type": "bonus",
              "tag": "Collect a bonus",
              "title": "Stress <color>ball</color>",
              "text": "Use this fidget to improve focus.",
              "sticker": "popin_pedro_2_4_bonus",
              "audio": "p2_handspinner_explainer",
              "background": "background4",
              "color": "1"
            }
          }
        },
        "popin5": {
          "steps": "1",
          "step": {
            "1": {
              "type": "obstacle",
              "tag": "Avoid the obstacle",
              "title": "Funky food <color>chaos</color>",
              "text": "Imagination can take you off task!",
              "sticker": "popin_pedro_2_5_malus",
              "background": "background2",
              "color": "2"
            }
          }
        }
      }
    },
    "caris": {
      "1": {
        "jauge": {
          "label": "Stress"
        },
        "popin1": {
          "steps": "2",
          "step": {
            "1": {
              "type": "goal",
              "tag": "1st goal",
              "title": "<color>Unscramble</color> the words.",
              "text": "Catch the correct letters to decode the words.",
              "sticker": "popin_caris_1_1_goal",
              "background": "background3",
              "color": "0"
            },
            "2": {
              "type": "bonus",
              "tag": "Collect a bonus",
              "title": "<color>Decoder</color> wheel",
              "text": "It helps you correct the spelling.",
              "sticker": "popin_caris_1_1_bonus",
              "audio": "TYCE-caris_With-this-decoder-1",
              "background": "background4",
              "color": "1"
            }
          }
        },
        "popin2": {
          "steps": "2",
          "step": {
            "1": {
              "type": "goal",
              "tag": "2nd goal",
              "title": "Break into <color>syllables</color>",
              "text": "Collect the syllables to help sound it out.",
              "sticker": "popin_caris_1_2_goal",
              "background": "background3",
              "color": "0"
            },
            "2": {
              "type": "bonus",
              "tag": "Collect a bonus",
              "title": "Confidence <color>booster</color>",
              "text": "A notebook filled with positive messages.",
              "sticker": "popin_caris_1_2_bonus",
              "audio": "TYCE-caris_My-notebook-1",
              "background": "background4",
              "color": "1"
            }
          }
        },
        "popin3": {
          "steps": "2",
          "step": {
            "1": {
              "type": "goal",
              "tag": "Final goal",
              "title": "Write what you <color>hear!</color>",
              "text": "Collect the words in the right order to take notes.",
              "sticker": "popin_caris_1_3_goal",
              "background": "background3",
              "color": "0"
            },
            "2": {
              "type": "obstacle",
              "tag": "Avoid the obstacle",
              "title": "Racing <color>heart</color>",
              "text": "Stress feels like pounding in your chest",
              "sticker": "popin_caris_1_3_malus",
              "audio": "TYCE-caris_When-I-get-stuck-1",
              "background": "background2",
              "color": "2"
            }
          }
        }
      },
      "2": {
        "popin1": {
          "steps": "2",
          "step": {
            "1": {
              "type": "goal",
              "tag": "1st goal",
              "title": "Learn the <color>moves</color>",
              "text": "Collect the right moves in the right order.",
              "sticker": "popin_caris_2_1_goal",
              "background": "background3",
              "color": "0"
            },
            "2": {
              "type": "bonus",
              "tag": "Collect a bonus",
              "title": "Video <color>replay</color>",
              "text": "It helps you remember the steps.",
              "sticker": "popin_caris_2_1_bonus",
              "audio": "TYCE-caris_video-explainer-1",
              "background": "background4",
              "color": "1"
            }
          }
        },
        "popin2": {
          "steps": "2",
          "step": {
            "1": {
              "type": "obstacle",
              "tag": "Avoid the obstacle",
              "title": "Face the <color>mirror!</color>",
              "text": "Mirror images can make the moves more confusing.",
              "sticker": "popin_caris_2_2_malus",
              "audio": "TYCE-caris_mirror-explainer-1",
              "background": "background2",
              "color": "2"
            },
            "2": {
              "type": "bonus",
              "tag": "Collect a bonus",
              "title": "Muscle <color>memory</color>",
              "text": "Practice a lot to help you remember the moves.",
              "sticker": "popin_caris_2_2_bonus",
              "audio": "TYCE-caris_Usually-I-memorize-1",
              "background": "background4",
              "color": "1"
            }
          }
        },
        "popin3": {
          "steps": "2",
          "step": {
            "1": {
              "type": "goal",
              "tag": "Final goal",
              "title": "<color>Audition!</color>",
              "text": "It’s time to show your moves.",
              "sticker": "popin_caris_2_3_goal",
              "background": "background3",
              "color": "0"
            },
            "2": {
              "type": "obstacle",
              "tag": "Avoid the obstacle",
              "title": "Left or <color>right?</color>",
              "text": "Sometimes it is hard to tell left from right.",
              "sticker": "popin_caris_2_3_malus",
              "audio": "TYCE-caris_When-Im-learning-1",
              "background": "background2",
              "color": "2"
            }
          }
        },
        "jauge": {
          "label": "Stress"
        }
      }
    },
    "francesca": {
      "1": {
        "jauge": {
          "label": "Frustration"
        },
        "popin1": {
          "steps": "2",
          "step": {
            "1": {
              "type": "goal",
              "tag": "1st goal",
              "title": "Solve the <color>equation!</color>",
              "text": "Grab the correct number.",
              "sticker": "popin_francesca_1_1_goal",
              "background": "background3",
              "color": "0"
            },
            "2": {
              "type": "bonus",
              "tag": "Collect a bonus",
              "title": "Hands-on <color>tools</color>",
              "text": "Use objects to help visualize the math.",
              "sticker": "popin_francesca_1_1_bonus",
              "audio": "TYCE_francesca_Scratch_handson",
              "background": "background4",
              "color": "1"
            }
          }
        },
        "popin2": {
          "steps": "2",
          "step": {
            "1": {
              "type": "goal",
              "tag": "2nd goal",
              "title": "Use the right <color>sign!</color>",
              "text": "Grab the right operator to add, subtract, or multiply.",
              "sticker": "popin_francesca_1_2_goal",
              "background": "background3",
              "color": "0"
            },
            "2": {
              "type": "obstacle",
              "tag": "Avoid the obstacle",
              "title": "Sign <color>switch!</color>",
              "text": "Avoid mixing up the operators.",
              "sticker": "popin_francesca_1_2_malus",
              "audio": "TYCE_francesca_Scratch_switch symbol",
              "background": "background2",
              "color": "2"
            }
          }
        },
        "popin3": {
          "steps": "4",
          "step": {
            "1": {
              "type": "goal",
              "tag": "Final goal",
              "title": "Multi-step <color>equations!</color>",
              "text": "Collect the right number. These are extra tricky!",
              "sticker": "popin_francesca_1_3_goal",
              "background": "background3",
              "color": "0"
            },
            "2": {
              "type": "bonus",
              "tag": "Collect a bonus",
              "title": "Use the <color>calculator</color>",
              "text": "It will highlight the correct answer.",
              "sticker": "popin_francesca_1_2_bonus",
              "audio": "TYCE_francesca_Scratch_calculators",
              "background": "background4",
              "color": "1"
            },
            "3": {
              "type": "obstacle",
              "tag": "Avoid the obstacle",
              "title": "Brain <color>barrier!</color>",
              "text": "It blocks your understanding.",
              "sticker": "popin_francesca_1_3_malus",
              "audio": "TYCE_francesca_Scratch_at times",
              "background": "background2",
              "color": "2"
            },
            "4": {
              "type": "obstacle",
              "tag": "Avoid the obstacle",
              "title": "Spider <color>invasion!</color>",
              "text": "Anxiety can take over your brain.",
              "sticker": "popin_francesca_1_3_malus-bis",
              "audio": "TYCE_francesca_Scratch_trouble figuring",
              "background": "background2",
              "color": "2"
            }
          }
        }
      },
      "2": {
        "popin1": {
          "steps": "2",
          "step": {
            "1": {
              "type": "goal",
              "tag": "1st goal",
              "title": "Shop for <color>groceries</color>",
              "text": "Collect the items without overspending!",
              "sticker": "popin_francesca_2_1_goal",
              "background": "background3",
              "color": "0"
            },
            "2": {
              "type": "obstacle",
              "tag": "Avoid the obstacle",
              "title": "Mystery <color>price</color>",
              "text": "It is hard to budget without prices.",
              "sticker": "popin_francesca_2_1_malus",
              "background": "background2",
              "color": "2"
            }
          }
        },
        "popin2": {
          "steps": "5",
          "step": {
            "1": {
              "type": "goal",
              "tag": "Final goal",
              "title": "Remove some <color>items</color>",
              "text": "Take out items to stay within your budget.",
              "sticker": "popin_francesca_2_2_goal",
              "background": "background3",
              "color": "0"
            },
            "2": {
              "type": "bonus",
              "tag": "Collect a bonus",
              "title": "Phone <color>calculator</color>",
              "text": "It helps you keep track of prices.",
              "sticker": "popin_francesca_2_2_bonus_1",
              "audio": "TYCE_francesca_Scratch_sometimes I need",
              "background": "background4",
              "color": "1"
            },
            "3": {
              "type": "bonus",
              "tag": "Collect a bonus",
              "title": "Deep <color>breath</color>",
              "text": "Take a breath to help slow things down.",
              "sticker": "popin_francesca_2_2_bonus_2",
              "background": "background4",
              "color": "1"
            },
            "4": {
              "type": "obstacle",
              "tag": "Avoid the obstacle",
              "title": "Price tag <color>chaos!</color>",
              "text": "Trouble with coin values can be confusing.",
              "sticker": "popin_francesca_2_2_malus_1",
              "audio": "TYCE_francesca_Scratch_knowing the value",
              "background": "background2",
              "color": "2"
            },
            "5": {
              "type": "obstacle",
              "tag": "Avoid the obstacle",
              "title": "Brain <color>freeze</color>",
              "text": "Your head hurts and you can’t think.",
              "sticker": "popin_francesca_2_2_malus_2",
              "audio": "TYCE_francesca_Scratch_too anxious",
              "background": "background2",
              "color": "2"
            }
          }
        },
        "jauge": {
          "label": "Frustration"
        }
      }
    }
  },
  "summary": {
    "nav": "Summary navigation",
    "meet": {
      "title": "Meet \nanother child",
      "cta": "Meet {{persona}}"
    },
    "scroll": "Scroll to see more",
    "backToTop": "Back to the top",
    "title": "Summary",
    "click": "Click to see more",
    "highlight": "Simulation highlights",
    "drag": "Drag to explore",
    "pedro": {
      "1": {
        "parallax": {
          "1": {
            "alt": "A jar full of flowers"
          },
          "2": {
            "alt": "A pencil case"
          }
        },
        "key_points": {
          "title": "Why was <color>getting ready</color> so hard for Pedro?",
          "text": "With <tag>ADHD</tag>, people can be trying really hard and still get distracted. We wanted you to experience how frustrating that can feel."
        },
        "description": {
          "title": "Key \ntakeaways",
          "introduction": "<tag>ADHD</tag> is a brain difference that makes it hard to pay attention.",
          "subtitle1": "Common challenges",
          "text1": "<ul><li><a href=\"https://www.understood.org/en/topics/distraction\">Distraction</a> makes it hard to keep track of time and get things done.</li>\n<li>Trouble with <a href=\"https://www.understood.org/en/articles/adhd-and-emotions-what-you-need-to-know\">managing emotion</a> means little things like spilled milk can spark big feelings.</li></ul>",
          "subtitle2": "Ways to help",
          "text2": "<ul><li><a href=\"https://www.understood.org/en/articles/school-morning-routines-tips\">Routines</a> and reminders are extra helpful for people with ADHD.</li>\n<li>Stretching and other <a href=\"https://www.understood.org/en/articles/school-morning-routines-tips\">calming strategies</a> can help people with ADHD manage their emotions.</li></ul>"
        },
        "slider": {
          "item": {
            "1": {
              "title": "Stretching",
              "text": "Stretching helps Pedro when things get stressful.",
              "type": "bonus",
              "tag": "Bonus"
            },
            "2": {
              "title": "Television",
              "text": "Pedro’s ADHD makes it hard to resist distractions like TV.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "3": {
              "title": "Spilled milk",
              "text": "With ADHD, even little things can spark big feelings.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "4": {
              "title": "Frida the dog",
              "text": "This playful pup can sidetrack Pedro in the morning.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "5": {
              "title": "Missing Sock",
              "text": "Pedro’s ADHD can make even simple tasks a big challenge.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "6": {
              "title": "Pedro’s Mom",
              "text": "Structure and reminders can help Pedro get back on task.",
              "type": "bonus",
              "tag": "Bonus"
            }
          }
        }
      },
      "2": {
        "parallax": {
          "1": {
            "alt": "Two carrots"
          },
          "2": {
            "alt": "A pizza slice"
          }
        },
        "key_points": {
          "title": "Why was <color>science class</color> so hard for Pedro?",
          "text": "<tag>ADHD</tag> makes it really challenging to stay on task. We wanted you to see what it feels like to try hard and still get off track."
        },
        "description": {
          "title": "Key \ntakeaways",
          "introduction": "<tag>ADHD</tag> is not a lack of willpower or intelligence.",
          "subtitle1": "Common challenges",
          "text1": "<ul><li>Trouble with <a href=\"https://www.understood.org/en/articles/understanding-impulsivity\">impulse control</a> can make it hard to sit still or to keep from blurting out jokes in class.</li>\n<li><a href=\"https://www.understood.org/en/articles/why-kids-daydream\">Daydreaming</a> can be a big challenge, like the way Pedro got lost in what he calls “Narnia.”</li></ul>",
          "subtitle2": "Ways to help",
          "text2": "<ul><li><a href=\"https://www.understood.org/en/articles/fidgets-for-kids-with-adhd\">Fidgets</a> and <a href=\"https://www.understood.org/en/articles/evidence-based-behavior-strategy-brain-breaks\">movement breaks</a> can help people with ADHD focus by giving them ways to burn off extra energy.</li>\n<li>Verbal and <a href=\"https://www.understood.org/en/articles/why-kids-dont-hand-in-their-work-even-if-they-did-it\">digital reminders</a> can help people with ADHD get back on track if they lose focus.</li></ul>"
        },
        "slider": {
          "item": {
            "1": {
              "title": "Class clown",
              "text": "ADHD can make it hard for Pedro to resist cracking jokes.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "2": {
              "title": "Hyperfocus",
              "text": "ADHD can help Pedro “lock in” on things that interest him.",
              "type": "bonus",
              "tag": "Bonus"
            },
            "3": {
              "title": "Pixelated brain",
              "text": "Losing focus makes it hard for Pedro to take in information.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "4": {
              "title": "Stress ball",
              "text": "Fidget tools can help Pedro focus.",
              "type": "bonus",
              "tag": "Bonus"
            },
            "5": {
              "title": "Funky food characters",
              "text": "Pedro’s imagination can go into overdrive.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "6": {
              "title": "Narnia’s door",
              "text": "Daydreaming can get Pedro way off task.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "7": {
              "title": "Pedro’s teacher",
              "text": "Pedro’s teacher helps him get back on track.",
              "type": "bonus",
              "tag": "Bonus"
            }
          }
        }
      }
    },
    "caris": {
      "1": {
        "parallax": {
          "1": {
            "alt": "Books"
          },
          "2": {
            "alt": "Headphone"
          }
        },
        "key_points": {
          "title": "Why were <color>reading and spelling</color> so hard for Caris?",
          "text": "<tag>Dyslexia</tag> is a brain difference that makes it hard to learn to read and spell. We wanted you to see what it feels like to try hard and still get off track."
        },
        "description": {
          "title": "Key takeaways",
          "introduction": "<tag>Dyslexia</tag> is not a problem with vision. It’s a brain difference that involves trouble recognizing the sounds in words and matching those sounds to letters.",
          "subtitle1": "Common challenges",
          "text1": "<ul><li><a href=\"https://www.understood.org/en/articles/decoding-what-it-is-and-how-it-works\">Decoding</a> means sounding out words by looking at the letters and figuring out how they go together. This is often a big challenge with dyslexia.</li>\n<li><a href=\"https://www.understood.org/en/articles/why-some-kids-struggle-with-spelling\">Spelling</a> can be even harder — thinking about the sounds in a word and turning them into letters. </li></ul>",
          "subtitle2": "Ways to help",
          "text2": "<ul><li><a href=\"https://www.understood.org/en/articles/phonics-rules-for-reading-and-spelling\">Learning phonics rules</a> in a clear, step-by-step way can help people with dyslexia make progress in reading and spelling.</li>\n<li><a href=\"https://www.understood.org/en/articles/classroom-accommodations-for-dyslexia\">Classroom accommodations</a>, like being given typed notes or an outline of the lesson, can help students who have trouble taking notes.</li></ul>"
        },
        "slider": {
          "item": {
            "1": {
              "title": "Scrambled letters",
              "text": "Dyslexia can make it hard to match letters with sounds.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "2": {
              "title": "Decoder wheel",
              "text": "Knowing the rules of phonics can help with dyslexia.",
              "type": "bonus",
              "tag": "Bonus"
            },
            "3": {
              "title": "Break into syllables",
              "text": "Caris splits long words into smaller parts.",
              "type": "bonus",
              "tag": "Bonus"
            },
            "4": {
              "title": "Racing heart",
              "text": "Caris feels like the stress is pounding in her chest.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "5": {
              "title": "Confidence booster",
              "text": "Caris keeps a notebook with positive messages.",
              "type": "bonus",
              "tag": "Bonus"
            },
            "6": {
              "title": "Taking notes",
              "text": "It’s hard to keep up when spelling is a challenge.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "7": {
              "title": "Masking",
              "text": "Pretending you don't need help can make things worse.",
              "type": "obstacle",
              "tag": "Obstacle"
            }
          }
        }
      },
      "2": {
        "parallax": {
          "1": {
            "alt": "Shoes"
          },
          "2": {
            "alt": "Boombox"
          }
        },
        "key_points": {
          "title": "Why were the <color>dance steps</color> so hard for Caris?",
          "text": "<tag>Dyslexia</tag> often involves challenges with learning left from right (and knowing which way letters like “b” and “d” should face). We wanted you to experience how frustrating that can feel."
        },
        "description": {
          "title": "Key takeaways",
          "introduction": "<tag>Dyslexia</tag> isn’t about how smart someone is. It’s a brain difference that involves challenges with memory and knowing where things are in space.",
          "subtitle1": "Common challenges",
          "text1": "<ul><li><a href=\"https://www.understood.org/en/articles/left-right-confusion\">Learning left from right</a> can be tricky with dyslexia and other kinds of learning differences.</li>\n<li><a href=\"https://www.understood.org/en/articles/sequential-memory-challenges-strategies\">Remembering things in order</a>, like the letters in a word or the steps in a dance, is another common challenge with dyslexia.</li></ul>",
          "subtitle2": "Ways to help",
          "text2": "<ul><li>Strategies like always wearing a bracelet on your left wrist can help with learning left from right.</li>\n<li>Breaking a task into smaller steps can make it easier to remember. Practicing helps, but only if you understand what you’re practicing. </li></ul>"
        },
        "slider": {
          "item": {
            "1": {
              "title": "Learn the moves",
              "text": "Dyslexia can impact sense of direction and memory.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "2": {
              "title": "Video replay",
              "text": "Watching a video helps Caris remember the moves.",
              "type": "bonus",
              "tag": "Bonus"
            },
            "3": {
              "title": "Face the mirror!",
              "text": "Mirror images can make the moves more confusing.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "4": {
              "title": "Left or right?",
              "text": "Stress makes it harder for Caris to tell left from right.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "5": {
              "title": "Muscle memory",
              "text": "Practice a lot to help you remember the moves.",
              "type": "bonus",
              "tag": "Bonus"
            }
          }
        }
      }
    },
    "francesca": {
      "1": {
        "parallax": {
          "1": {
            "alt": "A jar full of flowers"
          },
          "2": {
            "alt": "A pencil case"
          }
        },
        "key_points": {
          "title": "Why was <color>math class</color> so hard for Francesca?",
          "text": "<tag>Dyscalculia</tag> is a brain difference that makes it hard to understand math concepts and work with numbers. We wanted you to experience how frustrating that can feel."
        },
        "description": {
          "title": "Key\ntakeaways",
          "introduction": "<tag>Dyscalculia</tag> doesn’t mean a person isn’t smart. It’s also not the same as being nervous about math. But a lot of people with dyscalculia also feel anxious about math.",
          "subtitle1": "Common challenges",
          "text1": "<ul><li>Trouble with <a href=\"https://www.understood.org/en/articles/number-sense-what-you-need-to-know\">number sense</a> can make it hard to learn that “5” means the same thing as “five” and the Roman numeral “V.”</li>\n<li><a href=\"https://www.understood.org/en/articles/fact-fluency-an-evidence-based-math-strategy\">Remembering math facts</a> like 5 + 3 = 8 can be hard if you don’t have a solid understanding of how numbers work together.</li></ul>",
          "subtitle2": "Ways to help",
          "text2": "<ul><li>Using <a href=\"https://www.understood.org/en/articles/math-manipulatives\">hands-on tools</a> and visual aids can help people with dyscalculia see how numbers work. These tools can make math easier to understand.</li>\n<li><a href=\"https://www.understood.org/en/articles/self-care-for-kids-6-ways-to-self-regulate\">Calming strategies</a> can help manage the stress or anxiety that often comes along with dyscalculia.</li></ul>"
        },
        "slider": {
          "item": {
            "1": {
              "title": "Roman numerals",
              "text": "Dyscalculia can make math feel like an unfamiliar language.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "2": {
              "title": "Hands-on tools",
              "text": "Math cubes can help Francesca “see” the number concepts.",
              "type": "bonus",
              "tag": "Bonus"
            },
            "3": {
              "title": "Sign switch",
              "text": "Working with math symbols can be confusing.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "4": {
              "title": "Calculator",
              "text": "Francesca uses a calculator to check her work.",
              "type": "bonus",
              "tag": "Bonus"
            },
            "5": {
              "title": "Brain barrier",
              "text": "Dyscalculia can make Francesca’s brain feel blocked.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "6": {
              "title": "Spider invasion",
              "text": "Anxiety can be intense, like being attacked by spiders!",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "7": {
              "title": "Francesca’s teacher",
              "text": "Francesca’s teacher can help her calm down.",
              "type": "bonus",
              "tag": "Bonus"
            }
          }
        }
      },
      "2": {
        "parallax": {
          "1": {
            "alt": "A jar full of flowers"
          },
          "2": {
            "alt": "A pencil case"
          }
        },
        "key_points": {
          "title": "Why was <color>buying stuff</color> so hard for Francesca?",
          "text": "With <tag>dyscalculia</tag>, counting money or making change can be a big challenge — especially if you have to do the math in your head. We wanted you to experience how frustrating that can feel."
        },
        "description": {
          "title": "Key \ntakeaways",
          "introduction": "<tag>Dyscalculia</tag> affects more than just math class. It can cause challenges outside of school too.",
          "subtitle1": "Common challenges",
          "text1": "<ul><li><a href=\"https://www.understood.org/en/articles/counting-money-why-some-kids-struggle-with-it\">Working with coins</a> involves matching values to shapes and sizes. This can be hard for people with dyscalculia.</li>\n<li>Working with money also involves remembering the different values you need to add or subtract in your head. This is called <a href=\"https://www.understood.org/en/articles/what-is-mental-math\">mental math</a>. </li></ul>",
          "subtitle2": "Ways to help",
          "text2": "<ul><li><a href=\"https://www.understood.org/en/articles/how-games-can-help-kids-who-struggle-with-math\">Playing games</a> that involve money can help build math skills needed in real life.</li>\n<li>The right <a href=\"https://www.understood.org/en/articles/math-homework-tools-for-kids-with-dyscalculia\">math tools</a> can help with dyscalculia, like using a basic calculator to solve a problem that has more than one step. You still need to know the order of the operations, but trouble remembering math facts won’t slow down the work.</li></ul>"
        },
        "slider": {
          "item": {
            "1": {
              "title": "Working with coins",
              "text": "Counting money can be a challenge with dyscalculia.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "2": {
              "title": "Price tag chaos",
              "text": "Keeping track of prices involves a lot of mental math.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "3": {
              "title": "Deep breath",
              "text": "Taking a breath can help Francesca calm her anxiety.",
              "type": "bonus",
              "tag": "Bonus"
            },
            "4": {
              "title": "Brain freeze",
              "text": "Francesca’s brain can freeze up when doing math.",
              "type": "obstacle",
              "tag": "Obstacle"
            },
            "5": {
              "title": "Phone calculator",
              "text": "A calculator takes away the stress of mental math.",
              "type": "bonus",
              "tag": "Bonus"
            },
            "6": {
              "title": "Receipt panic",
              "text": "The total cost wasn’t what Francesca expected.",
              "type": "obstacle",
              "tag": "Obstacle"
            }
          }
        }
      }
    }
  },
  "debug": {
    "popin": {
      "tag": "Item catched!",
      "title1": "Oh yeees a <color>bonus</color>",
      "title2": "Oh nooo a <color>malus</color>",
      "title3": "Congrats an <color>achievement</color>",
      "text": "You’ll have to select the correct one!",
      "sticker": "magnifyingGlass",
      "cta": "Resume"
    }
  },
  "misc": {
    "alarm_clock": "Alarm clock",
    "cart": "Cart",
    "wallet": "Wallet",
    "freeze": "Freeze",
    "intro": {
      "title": "For the best and most comfortable experience:",
      "steps": [
        "Best viewed on a desktop and chromebook.",
        "Use headphones or turn up your sound.",
        "You can exit anytime if motion feels overwhelming."
      ],
      "cta": "Got it"
    }
  },
  "idle": {
    "title": "Choose persona",
    "text": "Select the simulation you want to run"
  },
  "child": {
    "pedro": {
      "name": "Pedro",
      "difference": "ADHD"
    },
    "caris": {
      "name": "Caris",
      "difference": "Dyslexia"
    },
    "francesca": {
      "name": "Francesca",
      "difference": "Dyscalculia"
    }
  },
  "scenario": {
    "pedro": {
      "1": {
        "title": "Morning routine"
      },
      "2": {
        "title": "Science class"
      }
    },
    "caris": {
      "1": {
        "title": "Social studies class"
      },
      "2": {
        "title": "Dance audition"
      }
    },
    "francesca": {
      "1": {
        "title": "Math class"
      },
      "2": {
        "title": "Grocery store"
      }
    }
  },
  "ending": {
    "pedro": {
      "1": {
        "title": "Oh no!",
        "subtitle": "You’re late to school again.",
        "cta": "Continue"
      },
      "2": {
        "title": "Uh-oh!",
        "subtitle": "You missed most of the lesson.",
        "cta": "Continue"
      }
    },
    "caris": {
      "1": {
        "title": "Oh no!",
        "subtitle": "You didn’t finish the work.",
        "cta": "Continue"
      },
      "2": {
        "title": "Good try!",
        "subtitle": "You worked hard but didn’t make the cut.",
        "cta": "Continue"
      }
    },
    "francesca": {
      "1": {
        "title": "Oh, no!",
        "subtitle": "You didn’t pass the test even though you worked hard.",
        "cta": "Continue"
      },
      "2": {
        "title": "Uh-oh!",
        "subtitle": "You didn’t get all the items on your shopping list.",
        "cta": "Continue"
      }
    }
  }
}
